import LoginPage from "../../features/authentication/login-page/login-page";

export default function Login() {
  return <LoginPage />;
}

Login.displayName = "Login";
